function isLocalHost(hostname = window.location.hostname) {
  return ['localhost', '127.0.0.1', '', '::1'].includes(hostname)
}

function createLinkConfig () {
  let linkConfig = {
    web: "/",
    h5: "/",
    online: "https://shunlong.s5.udesk.cn/im_client/?web_plugin_id=1812&group_id=1048",
    login: "https://fo.wsgoldfo003.com/Frontoffice/",
    disclaimer: "/disclaimer",
    risk: "/risk_disclosure",
    agreement: "/client_agreement",
    policy: "/privacy_policy",
    android: [
      "https://downloads.akklldownload.com/source/material/WSJY_GW.apk",
      "https://mp-18b59665-8ace-4294-a961-e5d5164f6bef.cdn.bspapp.com/GW/2025.5/WSJY_GW_v301.apk",
    ],
    android_backup: 
      "https://mp-18b59665-8ace-4294-a961-e5d5164f6bef.cdn.bspapp.com/GW/2025.5/WSJY_GW_v301.apk",
  };

  /**
   * 本地开发或者UAT 设定:
   * isLocalHost() || window.location.hostname.includes("atbgovernor")
   * 
   * 其余视为正式环境，动态域名
   */
  if (isLocalHost() || window.location.hostname.includes("atbgovernor")) {
    linkConfig.web = "https://wasin.atbgovernor.com";
    linkConfig.h5 = "http://h5-wasin-official.atbgovernor.com/?utm_source=tuijian";
  } else {
    const baseDomain = window.location.hostname.replace(/^[^.]+\./, '');
    linkConfig.web = `${window.location.protocol}//www.${baseDomain}`;
    linkConfig.h5 = `${window.location.protocol}//h5.${baseDomain}/?utm_source=gw`;
  }

  linkConfig.disclaimer = linkConfig.web + linkConfig.disclaimer;
  linkConfig.risk = linkConfig.web + linkConfig.risk;
  linkConfig.agreement = linkConfig.web + linkConfig.agreement;
  linkConfig.policy = linkConfig.web + linkConfig.policy;

  return linkConfig;
}

const sourceUrl = "_s_u_l_";
const linkConfig = createLinkConfig();
const signature = "wsjy";
export { linkConfig, sourceUrl, signature };
